<div mat-dialog-title>
  {{ data.name }}
  <div class="work-instruction-stepper-timer">
    <h6>{{ 'workInstructionStepper.totalProcessTime' | translate }}</h6>
    <span>{{ allStepsTotalTimer$ | async }}</span>
  </div>
</div>

<mat-drawer-container autosize class="h-70-vh">
  <mat-drawer #drawer mode="side" opened="true" position="start">
    <mat-horizontal-stepper
      orientation="vertical"
      [selectedIndex]="selectedStepIndex()"
      (click)="onClickStep()"
      #stepper
    >
      <mat-step *ngFor="let step of store.steps(); trackBy: trackByStepId" label="{{ step.id }}">
        <ng-template matStepLabel>
          <div>{{ step.name }}</div>
          <div class="d-flex align-items-center">
            <mat-pill
              *ngIf="!step?.submission"
              text="{{ 'workInstructionStepper.status.notStarted' | translate }}"
            ></mat-pill>
            <mat-pill
              *ngIf="step?.submission && step?.submission?.endedAt === null && step.submission?.lastPlayedAt !== null"
              text="{{ 'workInstructionStepper.status.ongoing' | translate }}"
            ></mat-pill>
            <mat-pill
              *ngIf="step?.submission && step?.submission?.endedAt === null && step.submission?.lastPlayedAt === null"
              text="{{ 'workInstructionStepper.status.paused' | translate }}"
            ></mat-pill>
            <mat-pill
              *ngIf="step?.submission?.endedAt"
              text="{{ 'workInstructionStepper.status.completed' | translate }}"
              class="green"
            ></mat-pill>
            <span class="mx-3 process-time">{{
              (stepIdToProgressesTimeMap$ | async)?.get(step.id) ?? '00:00:00'
            }}</span>
          </div>
        </ng-template>
      </mat-step>
      <ng-template matStepperIcon="edit" let-index="index">
        {{ index + 1 }}
      </ng-template>
      <ng-template matStepperIcon="number" let-index="index">
        {{ index + 1 }}
      </ng-template>
    </mat-horizontal-stepper>
  </mat-drawer>
  <h3 *ngIf="store.dataLoading() === ELoadStatus.success && !selectedStep()?.form">
    {{ 'workInstructionStepper.emptyForm' | translate }}
  </h3>
  <app-scw-formio
    *ngIf="selectedStep()?.form"
    [form]="selectedStep()?.form ?? {}"
    [submission]="selectedSubmission()?.formData"
    (submitted)="onSubmit($event)"
    (changed)="onChangedForm($event)"
    (isValid)="isFormValid = $event"
    (draft)="draft = $event"
  ></app-scw-formio>
</mat-drawer-container>
<mat-dialog-actions align="center">
  <button mat-stroked-button [disabled]="isSelectedStepTheFirstInOrder()" (click)="changeStep(selectedStepIndex() - 1)">
    {{ 'button.previous' | translate }}
    <mat-icon>arrow_back</mat-icon>
  </button>
  <button
    mat-stroked-button
    [disabled]="store.combinedStatus() === ELoadStatus.loading"
    (click)="pauseOrResumeStepTimer()"
  >
    {{ timerData().buttonText | translate }}
    <mat-icon>{{ timerData().icon }}</mat-icon>
  </button>
  <span class="mx-3">{{ selectedItemAssignedWorkInstructionStepTimer$ | async }}</span>
  <button mat-stroked-button [disabled]="isSelectedStepTheLastInOrder()" (click)="changeStep(selectedStepIndex() + 1)">
    {{ 'button.next' | translate }}
    <mat-icon>arrow_forward</mat-icon>
  </button>
  <button mat-stroked-button (click)="saveStep()">
    <mat-icon>save</mat-icon>
    {{ 'button.save' | translate }}
  </button>
  <button mat-flat-button *ngIf="!selectedStep()?.submission?.endedAt" (click)="onSubmit(draft)">
    <mat-icon>check_circle</mat-icon>
    {{ 'button.complete' | translate }}
  </button>
  <button mat-button mat-dialog-close>{{ 'button.close' | translate }}</button>
</mat-dialog-actions>
